export function manageScript({ url, id, remove }: { url: string; id?: string; remove?: boolean }) {
  const scripts = document.getElementsByTagName('script');
  let scriptExists = false;
  for (let i = scripts.length; i--; ) {
    if (scripts[i].src.includes(url)) {
      scriptExists = true;
      if (remove) {
        scripts[i].parentNode?.removeChild(scripts[i]);
      }
    }
  }

  if (!scriptExists && !remove) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    if (id) {
      script.id = id;
    }
    script.async = true;
    script.defer = true;
    script.src = url;
    document.body.appendChild(script);
  }
}
